import {http} from '@/helpers/http-helper';

class Activity {
    constructor(username, description, registered) {
        this.username = username;
        this.description = description;
        this.registered = registered;
    }
}

export const getUsersActivity = () => {

    return new Promise( (resolve, reject) => {

        const url = 'users/activity';

        http.get(url)
            .then((response) => {
                if (response.status === 200) {

                    let activities = [];

                    response.data.forEach((activity) => {
                        activities.push(new Activity(
                            activity.username,
                            activity.description,
                            new Date(activity.registered)
                        ));
                    });

                    resolve(activities);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getUserActivity = (userId) => {

    return new Promise( (resolve, reject) => {

        const url = 'users/' + userId + '/activity';

        http.get(url)
            .then((response) => {
                if (response.status === 200) {

                    let activities = [];

                    response.data.forEach((activity) => {
                        activities.push(new Activity(
                            activity.username,
                            activity.description,
                            new Date(activity.registered)
                        ));
                    });

                    resolve(activities);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};